import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import { media, TransitionMixin } from '../helpers';
import Wrapper from './wrapper';

const SimpleSplitSectionContainer = styled.div`
    background-color: #fff;
    .content-row-wrapper {
        position: relative;
        z-index: 100;
        ${media.small`max-width: 550px;`}
        ${media.medium`max-width: 650px;`}
        ${media.large`display: flex; max-width: 100vw;`}

        &.flipped {
            .image-container {
                order: 2;
            }
            .content-container {
                order: 1;
            }
        }

        .image-container {
            flex: 1;
        }
        .content-container {
            flex: 1;
            display: flex;
            align-items: center;
            .inner-wrap {
                margin: 0 auto;
                text-align: center;
                padding: 20px 0 40px;
                max-width: 90vw;
                ${media.small`max-width: 550px; `}

                h3 {
                    font-size: 2rem;
                    color: #000;
                    font-family: neue-kabel, sans-serif;
                    font-weight: 800;
                    margin: 0 0 20px;
                }

                ul {
                    padding: 0 0 20px;
                    margin: 0;
                    list-style: none;
                    li {
                        display: inline-block;
                        margin-right: 15px;

                        &:last-child {
                            margin-right: 0px;
                        }

                        a {
                            font-weight: bold;
                            color: #000;
                            font-size: 1rem;
                            text-decoration: none;
                            ${TransitionMixin('.25s')}
                            &:hover {
                                opacity: 0.7;
                            }
                        }
                    }
                }

                p {
                    font-size: 1rem;
                    line-height: 1.5;
                    color: #000;
                }
            }
        }
    }
`;

const SimpleSplitSection = ({ rows }) => {
    function isOdd(num) {
        return num % 2;
    }

    return (
        <SimpleSplitSectionContainer>
            {rows &&
                rows.map((row, index) => {
                    const {
                        contentRowImage,
                        contentRowTitle,
                        contentRowLinks,
                        contentRowDescription,
                        contentRowContent,
                        contentRowButton,
                    } = row || {};

                    const isOddRow = isOdd(index) === 1;

                    return (
                        <Wrapper
                            key={index}
                            className={
                                isOddRow
                                    ? 'content-row-wrapper flipped'
                                    : 'content-row-wrapper'
                            }
                        >
                            <div className="image-container">
                                {contentRowImage && (
                                    <Img
                                        fluid={
                                            contentRowImage.localFile
                                                .childImageSharp.fluid
                                        }
                                    />
                                )}
                            </div>
                            <div className="content-container">
                                <div className="inner-wrap">
                                    <h3>{contentRowTitle}</h3>
                                    {contentRowLinks && (
                                        <ul>
                                            {contentRowLinks.map(
                                                (linkNode, linkIndex) => {
                                                    let link = linkNode.link;
                                                    return (
                                                        <>
                                                            <li key={linkIndex}>
                                                                <Link
                                                                    to={
                                                                        link.url
                                                                    }
                                                                >
                                                                    {link.title}
                                                                </Link>
                                                            </li>
                                                            {linkIndex <
                                                                contentRowLinks.length -
                                                                    1 && (
                                                                <li>|</li>
                                                            )}
                                                        </>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    )}
                                    <p>
                                        {contentRowDescription ||
                                            contentRowContent}
                                    </p>
                                </div>
                            </div>
                        </Wrapper>
                    );
                })}
        </SimpleSplitSectionContainer>
    );
};

export default SimpleSplitSection;
